<template>
  <div style="height: 100%">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  height: 100%;
}

body {
  min-width: 1300px;
  overflow: auto;
}

li {
  list-style: none;
}

.clearfix:after {
  content: "";
  /*转换为一个块元素*/
  display: block;
  /*清除两侧的浮动*/
  clear: both;
}
/*在ie6中不支持after伪类处理*/
.clearfix {
  zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue